import { forwardRef, RefObject } from 'react';
import { useTranslations } from 'next-intl';
import { IProduct, IProductSectionName } from '@monofront/types';
import RedirectionCard, {
  Button,
  Subtitle,
  Title,
} from '@monofront/design-system/components/RedirectionCard';
import ArrowRight from '@monofront/design-system/visuals/Icons/ArrowRight';
import { IconSizes } from '@monofront/design-system/visuals/Icons/type';

interface IProductVendorProps {
  product: IProduct;
  name: IProductSectionName;
  ref: RefObject<HTMLHeadingElement | null>;
}

const ProductVendor = forwardRef<HTMLHeadingElement, IProductVendorProps>(
  ({ product, name }, ref) => {
    const tProducts = useTranslations('Products');
    const whyThisVendor = product.meta.marketing?.why_this_vendor;
    const vendorLink = product.vendor_collection
      ? `/collections/${product.vendor_collection.handle}`
      : `/collections/all?vendor=${product.vendor}`;

    if (!whyThisVendor) return null;

    return (
      <>
        <h2
          ref={ref}
          id="section-vendor"
          className="section-title tw-lf-title-sm tw-mb-6 tw-mt-[4.5rem] desktop:tw-lf-title-md"
          data-menu={name.menuTitle ? name.menuTitle : tProducts('vendor')}
          tabIndex={-1}
        >
          {name.sectionTitle
            ? name.sectionTitle.replace('%PRODUCT_NAME%', product.title)
            : tProducts('vendor')}
        </h2>

        <div
          className="tw-lf-rich-text"
          dangerouslySetInnerHTML={{
            __html: whyThisVendor,
          }}
        />
        <RedirectionCard
          url={vendorLink}
          isTargetBlank
          UNSAFE_className="tw-mt-6 tw-mb-4"
        >
          <Title>{product.vendor}</Title>
          <Subtitle>{tProducts('vendorLinkSubTitle')}</Subtitle>
          <Button>
            <ArrowRight size={IconSizes.md} />
          </Button>
        </RedirectionCard>
      </>
    );
  },
);

export default ProductVendor;
